import { render, staticRenderFns } from "./ManageServiceRefactored.vue?vue&type=template&id=57f97620"
import script from "./ManageServiceRefactored.vue?vue&type=script&lang=js"
export * from "./ManageServiceRefactored.vue?vue&type=script&lang=js"
import style0 from "./ManageServiceRefactored.vue?vue&type=style&index=0&id=57f97620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports